var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-body-2"
  }, [_vm.items ? [_vm._l(_vm.itemsWithDividers, function (item) {
    return !item.key || item.key != 'TAX' || parseInt(item.unit) ? _c('div', {
      staticClass: "mb-1 relative"
    }, [!item.key && !_vm.hideSeparators ? _c('v-divider', {
      staticClass: "my-3"
    }) : _vm._e(), item.key ? [_c('div', {
      staticClass: "d-flex align-center relative"
    }, [item.key == 'TAX' ? _c('div', [_vm._v(_vm._s(item.meta.description))]) : item.key == 'SUBSCRIPTION' ? _c('div', [_vm._v(" " + _vm._s(item.meta.code.charAt(0).toUpperCase() + item.meta.code.substr(1).toLowerCase()) + " subscription ")]) : _c('div', [_vm._v(_vm._s(item.title || item.key))]), item.disclaimer && item.disclaimer(_vm.items) ? _c('v-btn', {
      staticClass: "ml-1 my-n3",
      attrs: {
        "small": "",
        "icon": "",
        "color": "primary"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.$confirm({
            msg: item.disclaimer(_vm.items),
            buttons: ['Ok'],
            primary: 'Ok',
            persistent: false
          });
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiInformation)
      }
    })], 1) : _vm._e(), item.qty != 1 ? _c('div', {
      staticClass: "ml-2 grey--text",
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v("× " + _vm._s(item.qty))]) : _vm._e(), _c('v-spacer'), _c('price', {
      staticClass: "ml-2",
      attrs: {
        "color": item.unit.startsWith('-') ? 'green' : 'black',
        "value": (parseInt(item.unit.replace('.', '')) * item.qty / 100).toFixed(2)
      }
    })], 1), _c('div', {
      staticClass: "ml-4 overline short grey--text pr-16 relative",
      staticStyle: {
        "font-size": ".6rem !important",
        "line-height": ".8rem !important"
      }
    }, [item.key == 'GIFTCARD' ? [_c('currency', {
      attrs: {
        "code": item.meta.cur
      }
    }), _vm._v(_vm._s(item.meta.amt) + " " + _vm._s(item.meta.name) + " ")] : item.key == 'CARD_CREDIT' ? [_vm._v(_vm._s(item.meta.code.split('@')[0]))] : item.key == 'BULK_PACK' ? [_vm._v(_vm._s(item.meta.code))] : item.key == 'CREDIT_PACK' ? [_vm._v(" $" + _vm._s(item.meta.amt.split('.')[0]) + " credit"), parseFloat(item.meta.amt) > 10 ? [_vm._v(" at " + _vm._s(100 * (parseFloat(item.meta.amt) - parseFloat(item.unit)) / parseFloat(item.meta.amt)) + "% off")] : _vm._e()] : item.key == 'VIDEO_CREDIT' ? [_vm._v(_vm._s(item.meta.code))] : item.key == 'PCT_DISCOUNT' ? [_vm._v(" " + _vm._s(item.meta.pct * 100 + '% × ' + item.meta.subtotal) + " ")] : item.key == 'SUBSCRIPTION' ? [_vm._v(" " + _vm._s(item.meta.cadence)), ['BUSINESS', 'MULTI-USER'].includes(item.meta.code) ? _c('span', [_vm._v(" • " + _vm._s(item.meta.max == 3 ? '1 – 3' : `up to ${item.meta.max}`) + " users • " + _vm._s(_vm.getNSends(item.meta)))]) : _vm._e()] : item.key == 'SUBSCRIPTION_UPGRADE' ? [_vm._v(" " + _vm._s(item.meta.cadence)), ['BUSINESS', 'MULTI-USER'].includes(item.meta.code) ? _c('span', [_vm._v(" • " + _vm._s(item.meta.max == 3 ? '1 – 3' : `up to ${item.meta.max}`) + " users • " + _vm._s(_vm.getNSends(item.meta)))]) : _vm._e()] : item.key == 'SUBSCRIPTION_CREDIT' ? [_vm._v(" " + _vm._s(item.meta.days_total - item.meta.days_elapsed) + " / " + _vm._s(item.meta.days_total) + " days unused ")] : _vm._e()], 2)] : _vm._e()], 2) : _vm._e();
  }), _vm.total ? _c('v-divider', {
    staticClass: "my-3"
  }) : _vm._e()] : _vm._e(), _vm.total ? _c('div', {
    staticClass: "d-flex font-weight-bold"
  }, [_c('div', [_vm._v("Total")]), _c('v-spacer'), _c('price', {
    attrs: {
      "color": _vm.itemized.price.startsWith('-') ? 'red' : null,
      "value": _vm.itemized.price
    }
  })], 1) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }